import React from 'react';
import { Flex, FlexProps } from '@withjoy/joykit';

type CircleColoredIconProps = Readonly<{
  background: string;
  borderColor?: FlexProps['borderColor'];
}>;

export const CircleColoredIcon: React.FC<CircleColoredIconProps> = ({ background, borderColor = 'transparent' }) => {
  return (
    <Flex
      width={6}
      height={6}
      borderRadius="100%"
      background={background}
      border="1px solid"
      borderColor={borderColor}
    />
  );
};
